import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './MortgageOffersNotFound.css';
import { MORTGAGE_LINK } from '../../../../constants/mortgage';

interface IMortgageOffersNotFoundProps {
  onMortgageLinkClick(): void;
}

export const MortgageOffersNotFound: React.FC<IMortgageOffersNotFoundProps> = ({ onMortgageLinkClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['image']} />
      <div className={styles['title']}>
        <ArticleHeading4 color="text-primary-default">
          Нет подходящих предложений от банков и застройщиков
        </ArticleHeading4>
      </div>
      <ArticleParagraph2 color={'text-secondary-default'} textAlign={'center'}>
        Измените параметры или{' '}
        <a
          className={styles['link']}
          href={MORTGAGE_LINK}
          target="blank"
          rel="noreferrer"
          onClick={onMortgageLinkClick}
        >
          подайте заявку
        </a>
      </ArticleParagraph2>
    </div>
  );
};
